export const DEFAULT_PER_PAGE_BLOGS = 10

export const GET_BLOGS = 'admin/get_blogs'
export const CREATE_ARTICLE = 'admin/article_create'
export const UPDATE_ARTICLE = 'admin/article_update'
export const DELETE_ARTICLE = 'admin/delete_article'
